const ICONS: Record<string, string> = {
  accommodation:
    '<path d="M3 22V9l9-7 9 7v13"/><path d="M9 22V12h6v10"/>',
  events:
    '<path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/>',
  dining:
    '<path d="M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/>',
  spa:
    '<path d="M12 22c-4.97 0-9-2.686-9-6v-.5C3 12.462 7.03 10 12 10s9 2.462 9 5.5v.5c0 3.314-4.03 6-9 6z"/><path d="M12 10c2.21 0 4-2.686 4-6S12 2 12 2 8 1.314 8 4s1.79 6 4 6z"/>',
  picnic:
    '<circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/>',
  tasting:
    '<path d="M8 2h8l-2 8H10L8 2z"/><path d="M12 10v8"/><path d="M8 18h8"/>',
  club:
    '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
  tour:
    '<polyline points="3 7 9 4 15 7 21 4 21 17 15 20 9 17 3 20 3 7"/><line x1="9" y1="4" x2="9" y2="17"/><line x1="15" y1="7" x2="15" y2="20"/>',
  custom: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>',
};

export function ServiceIcon({
  type,
  customSvg,
}: {
  type: string;
  customSvg?: string | null;
}) {
  if (customSvg && customSvg.trim().length > 0) {
    // Tenant-supplied SVG has already been sanitised server-side on save.
    return (
      <span
        className="vt-tab-custom-icon"
        dangerouslySetInnerHTML={{ __html: customSvg }}
      />
    );
  }

  const path = ICONS[type] ?? ICONS.custom;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: path! }}
    />
  );
}
